
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Shield, Key } from 'lucide-react';
import { User } from '@/types/userRole';

interface MasterDashboardHeaderProps {
  user: User | null;
}

const MasterDashboardHeader: React.FC<MasterDashboardHeaderProps> = ({ user }) => {
  const navigate = useNavigate();
  
  return (
    <header className="mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div>
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-bold flex items-center">
              <Shield className="mr-2 h-6 w-6 text-indigo-600" />
              Master Dashboard
            </h1>
            {user && (
              <span 
                className="text-sm font-semibold px-3 py-1 rounded-full" 
                style={{ backgroundColor: '#F97316', color: 'white' }}
              >
                {user.role?.toUpperCase() || 'MASTER ADMIN'}
              </span>
            )}
          </div>
          <p className="text-gray-600 mt-1">
            Manage license keys, domains and Super Admin access
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex gap-2">
          <Button onClick={() => navigate('/master-license/license-keys')}>
            <Key className="mr-2 h-4 w-4" />
            Manage Licenses
          </Button>
        </div>
      </div>
    </header>
  );
};

export default MasterDashboardHeader;
